import { useIsLoggedIn } from "@nf/common";
import { ROUTES } from "@nf/constants";
import { Trans, useTranslation } from "next-i18next";
import { isMobile } from "react-device-detect";

import LinkText from "components/LinkText";
import OfferButton from "components/OfferButton";

import styles from "./MobileSignUpComponent.module.scss";

export const MobileSignUpComponent = () => {
  const { t } = useTranslation("translations");
  const isLoggedIn = useIsLoggedIn();

  return isMobile && !isLoggedIn ? (
    <div className={styles.container}>
      <OfferButton />
      <span className={styles.login}>
        <Trans
          i18nKey={t("web_signup_login")}
          components={{
            1: <LinkText bold href={ROUTES.LOGIN}></LinkText>,
          }}
        />
      </span>
    </div>
  ) : null;
};
